import styles from "./lesson-title.module.css"

import { mergeAttributes, Node } from "@tiptap/core"
import { ReactNodeViewRenderer } from "@tiptap/react"
import { cancelBackspaceAtNodeStart } from "../../util/cancel-backspace-at-node-start"
import { splitLessonTitle } from "../../util/split-lesson-title"
import { LessonTitleComponent } from "./lesson-title-component"

export const ExtensionLessonTitle = Node.create({
  name: "lessonTitle",
  content: "text*",
  marks: "",

  renderHTML({ HTMLAttributes }) {
    return [
      "h1",
      mergeAttributes(HTMLAttributes, {
        "data-content-type": "lessonTitle",
        class: styles.lessonTitle,
      }),
      0,
    ]
  },

  parseHTML() {
    return [
      {
        tag: 'h1[data-content-type="lessonTitle"]',
      },
    ]
  },

  addKeyboardShortcuts() {
    return {
      Enter: () => splitLessonTitle(this.editor, this.name),
      "Shift+Enter": () => splitLessonTitle(this.editor, this.name),
      Backspace: () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Shift-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Mod-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Alt-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(LessonTitleComponent)
  },
})
